module.exports = __webpack_public_path__ + "img/icon3.9772d5f6.svg";